import { RequestService } from '@/api/services/request.service';
import { Subscribe } from '@/types/subscribe-purchase-fish';

export async function subscribeForFish(subscribe: Subscribe) {
	const request = RequestService.getInstance();
	try {
		await request.post(`${process.env.HOST}/api_v1/subscribe-for-fish/`, subscribe);
	} catch (error) {
		if (error.response?.status === 409) {
			throw new Error('У вас уже есть подписка с такими свойствами');
		} else {
			console.error('Error subscribing for fish:', error);
			throw new Error('Ошибка при подписке на рыбу');
		}
	}
}
